import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import api from "../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      const response = await api.login(formData);
      const token = response.token || (response.data && response.data.token);
      const user = response.user || (response.data && response.data.user);
      if (token && user) {
        localStorage.setItem("token", token);
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("user_id", user.id);
        localStorage.setItem("user_name", user.name);
        localStorage.setItem("user_email", user.email);
        localStorage.setItem("user_role", user.role);
        localStorage.setItem("user_is_portal", user.is_portal);
        localStorage.setItem("user_phone", user.phone);
        localStorage.setItem("user_email_verified_at", user.email_verified_at);
        localStorage.setItem("user_created_at", user.created_at);
        localStorage.setItem("user_updated_at", user.updated_at);
        localStorage.setItem("user_deleted_at", user.deleted_at);
        if (user.is_portal) {
          toast.success("Login successful! Redirecting...");
          setTimeout(() => navigate("/dashboard"), 1200);
        } else {
          toast.error("Login through the app");
        }
      } else {
        setError("Invalid login response: token or user not found.");
        toast.error("Login failed: token or user not found in response.");
      }
    } catch (err) {
      let errorMsg = "Login failed";
      // Try to extract a clean message from the error
      if (err && err.message) {
        // Try to parse JSON error message from API
        const match = err.message.match(/\{.*\}/);
        if (match) {
          try {
            const json = JSON.parse(match[0]);
            if (json.message) {
              errorMsg = json.message;
            } else {
              errorMsg = match[0];
            }
          } catch {
            errorMsg = err.message;
          }
        } else {
          errorMsg = err.message;
        }
      }
      // Only show error in toast, not above the fields
      setError("");
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Islamabad Safe City Survey Portal</h1>
          <p>Welcome back! Please sign in to your account.</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {/* Error message removed, only toast will show errors */}

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your password"
              required
            />
          </div>

          {/* <div className="form-options">
            <label className="checkbox-container">
              <input type="checkbox" />
              <span className="checkmark"></span>
              Remember me
            </label>
            <a href="#" className="forgot-password">Forgot password?</a>
          </div> */}

          <button
            type="submit"
            className="btn btn-primary login-btn"
            style={{ color: "white", backgroundColor: "#172453" }}
            disabled={isLoading}
          >
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        {/* <div className="login-footer">
          <p>Don't have an account? <a href="#" className="signup-link">Sign up here</a></p>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
